import React, { useEffect, useState } from 'react'
import { Icon } from 'react-icons-kit'
import { whatsapp } from 'react-icons-kit/fa/whatsapp'
import { animations } from 'react-animation'
import './whatsappButton.css'
import Emp from '../utilitarios/infoEmpresa'
import ReactPixel from 'react-facebook-pixel'
const empresa = new Emp()

export default function WhatsAppButton() {
    const [number, setNumber] = useState()

    useEffect(() =>
        empresa.getInfoEmpresa().then(data =>  setNumber(data.Whatsapp))
        , [])



    return (
        <React.Fragment>
            {
                number &&
                <a 
                href={`https://api.whatsapp.com/send?phone=${number}&text=Hola%20Electrica%20Caporale!`} 
                className="WhatsappButtonFixed" 
                target="_blank" 
                underline="none" 
                style={{ animation: animations.popIn }}
                onClick={ReactPixel.fbq('track', 'Contact')}
                >
                    <Icon size={45} icon={whatsapp} className="WhatsappButtonFixedIcon" />
                </a>

            }
        </React.Fragment>
    )
}

/* <a style={{ animation: animations.popIn }} target="_blank" className={classes.WhatsappButtonFixed} href={`https://api.whatsapp.com/send?phone=${number}&text=Hola!`}>

                    <Icon className="WhatsappButtonFixedIcon" size={42} icon={whatsapp} />}
                </a> */